@charset "UTF-8";

/* app/js/src/components/clipping-studio/panels/media-panel/clipping-studio-media-panel.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.media-panel__body::-webkit-scrollbar {
  height: 11px;
  overflow: visible;
  width: 11px;
  opacity: 1;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.media-panel__body::-webkit-scrollbar-button {
  height: 0;
  width: 0;
}
.media-panel__body::-webkit-scrollbar-corner {
  background: transparent;
}
.media-panel__body::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
.media-panel__body::-webkit-scrollbar-thumb {
  background-color: #e3e6ea;
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
  min-height: 28px;
  padding: 100px 0 0;
  border-radius: 10px;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.media-panel__body::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
.media-panel__body::-webkit-scrollbar-track:hover {
  background-color: #eef2f6;
}
.media-panel__body::-webkit-scrollbar-track {
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
}
.media-panel {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  font-family: "Open Sans", sans-serif;
}
.media-panel__tabs {
  display: flex;
  border-bottom: 1px solid rgba(0, 0, 0, 0.14);
  flex-shrink: 0;
}
.media-panel__tab {
  flex: 1;
  padding: 12px 8px;
  font-size: 13px;
  font-weight: 700;
  border: none;
  border-bottom: 2px solid transparent;
  background: transparent;
  color: rgba(0, 0, 0, 0.54);
  cursor: pointer;
  transition: border-color 0.2s ease, color 0.2s ease;
}
.media-panel__tab:hover {
  color: rgba(0, 0, 0, 0.85);
}
.media-panel__tab--active {
  border-bottom-color: rgb(45, 187, 252);
  color: rgb(45, 187, 252);
  background: rgba(45, 187, 252, 0.06);
}
.media-panel__header {
  display: flex;
  align-items: center;
  padding: 16px;
  border-bottom: 1px solid rgb(226, 232, 241);
  flex-shrink: 0;
}
.media-panel__title {
  font-size: 18px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.85);
  margin: 0;
}
.media-panel__body {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.media-panel__section {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.media-panel__section-label {
  display: block;
  font-size: 10px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.35);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
.media-panel__search-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  min-width: 0;
}
.media-panel__search-wrapper ichannel-input {
  flex: 1;
}
.media-panel__search-wrapper ::ng-deep ichannel-input input {
  border-radius: 6px;
}
.media-panel__search-wrapper ::ng-deep ichannel-input > div.rowInput,
.media-panel__search-wrapper ::ng-deep ichannel-input > div {
  margin-bottom: 0;
}
.media-panel__search-clear {
  margin-left: 8px;
  background: none;
  border: none;
  font-size: 18px;
  color: rgba(0, 0, 0, 0.54);
  cursor: pointer;
  padding: 0 4px;
  line-height: 1;
}
.media-panel__search-clear:hover {
  color: rgba(0, 0, 0, 0.85);
}
.media-panel .filter-option-header {
  font-size: 12px;
  font-family: "OpenSans";
  color: #7d8fa1;
  margin-bottom: 5px;
  display: block;
}
.media-panel .tag-list-container,
.media-panel .languages-list-container {
  padding-left: 0;
  margin-top: 0;
  margin-bottom: 0;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
}
.media-panel .tag-list-container li,
.media-panel .languages-list-container li {
  margin: 7px 8px 6px 0;
}
.media-panel .tag-list-container .display-none,
.media-panel .languages-list-container .display-none {
  display: none;
}
.media-panel .tag-list-container .more-tags label,
.media-panel .languages-list-container .more-tags label {
  padding-top: 8px;
  padding-bottom: 8px;
  height: 26px;
  line-height: 0;
}
.media-panel .tag-list-container .more-tags input + label::after,
.media-panel .languages-list-container .more-tags input + label::after {
  font-family: "OpenSans";
  content: "...";
  color: #879baf;
  font-size: 20px;
  line-height: 0;
}
.media-panel .tag-list-container .more-tags:hover label,
.media-panel .languages-list-container .more-tags:hover label {
  background-color: #40c4ff;
}
.media-panel .tag-list-container .more-tags:hover input + label::after,
.media-panel .languages-list-container .more-tags:hover input + label::after {
  color: white;
}
.media-panel .tag-list-container .less-tags label,
.media-panel .languages-list-container .less-tags label {
  padding-bottom: 0;
}
.media-panel .tag-list-container .less-tags input + label::after,
.media-panel .languages-list-container .less-tags input + label::after {
  font-family: "OpenSans";
  content: "^";
  color: #879baf;
  font-size: 20px;
  line-height: 17px;
}
.media-panel .tag-list-container .less-tags:hover label,
.media-panel .languages-list-container .less-tags:hover label {
  background-color: #40c4ff;
}
.media-panel .tag-list-container .less-tags:hover input + label::after,
.media-panel .languages-list-container .less-tags:hover input + label::after {
  color: white;
}
.media-panel .tag-list-container .input-hidden,
.media-panel .languages-list-container .input-hidden {
  display: none;
}
.media-panel .tag-list-container label,
.media-panel .languages-list-container label {
  color: #879baf;
  border: 1px solid #dde3e7;
  font-family: "OpenSans";
  font-size: 12px;
  border-radius: 6px;
  padding: 5px 12px 5px 12px;
  display: inline-block;
}
.media-panel .tag-list-container label:hover,
.media-panel .languages-list-container label:hover {
  cursor: pointer;
}
.media-panel .tag-list-container input:checked + label,
.media-panel .languages-list-container input:checked + label {
  border-color: #40c4ff;
  color: #232f3a;
}
.media-panel__sort-section {
  padding-top: 12px;
  border-top: 1px solid rgb(226, 232, 241);
}
.media-panel__dropdown {
  width: 100% !important;
  min-width: 0;
  max-width: 100%;
  display: block;
  border-radius: 6px;
}
.media-panel__grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  padding-bottom: 20px;
}
.media-panel__mam-list {
  display: flex;
  flex-direction: column;
  gap: 0;
  padding-bottom: 20px;
  flex: 1;
  min-height: 0;
}
.media-panel__mam-list > * {
  min-width: 0;
}
.media-panel__loading-more {
  padding: 8px 0 16px;
  text-align: center;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.54);
}
.media-panel__loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 48px 24px;
  gap: 12px;
  min-height: 160px;
}
.media-panel__loading-icon {
  width: 48px;
  height: auto;
  animation: media-panel-loading-pulse 1s ease-in-out infinite;
}
.media-panel__loading-text {
  margin: 0;
  font-size: 13px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.54);
}
.media-panel__card {
  background: rgb(255, 255, 255);
  border: 1px solid rgb(226, 232, 241);
  border-radius: 0;
  overflow: hidden;
  cursor: pointer;
  transition: border-color 0.15s ease;
}
.media-panel__card:hover {
  border-color: rgba(22, 177, 255, 0.5);
}
.media-panel__card-thumbnail {
  position: relative;
  aspect-ratio: 16/9;
  overflow: hidden;
  background: rgba(35, 47, 58, 0.05);
}
.media-panel__card-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform 0.4s ease;
}
.media-panel__card:hover .media-panel__card-img {
  transform: scale(1.08);
}
.media-panel__card-duration {
  position: absolute;
  left: 4px;
  bottom: 4px;
  padding: 4px;
  font-size: 10px;
  letter-spacing: 0.1px;
  color: white;
  background-color: rgba(0, 0, 0, 0.6);
}
.media-panel__card-info {
  padding: 8px;
}
.media-panel__card-title {
  font-size: 11px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.85);
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: color 0.15s ease;
}
.media-panel__card:hover .media-panel__card-title {
  color: rgb(22, 177, 255);
}
.media-panel__empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 48px 24px;
  gap: 16px;
}
.media-panel__empty-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  border-radius: 0;
  background: rgba(35, 47, 58, 0.05);
  color: rgba(0, 0, 0, 0.35);
}
.media-panel__empty-text {
  font-size: 13px;
  color: rgba(0, 0, 0, 0.35);
  font-weight: 500;
  margin: 0;
  line-height: 1.5;
}
@keyframes media-panel-loading-pulse {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.65;
    transform: scale(0.96);
  }
}
/*# sourceMappingURL=clipping-studio-media-panel.component.css.map */
